import { render } from "./AnalyticSectionCreateComponent.vue?vue&type=template&id=58c0470c"
import script from "./AnalyticSectionCreateComponent.vue?vue&type=script&lang=js"
export * from "./AnalyticSectionCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/analytics/analyticSection/AnalyticSectionCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58c0470c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58c0470c', __exports__)) {
    api.reload('58c0470c', __exports__)
  }
  
  module.hot.accept("./AnalyticSectionCreateComponent.vue?vue&type=template&id=58c0470c", () => {
    api.rerender('58c0470c', render)
  })

}


export default __exports__